import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as productsActions from '../actions/products.actions';
import * as notifyActions from '../../general/actions/notify.actions';
import { MwProductApiService } from 'app/services/product-api.service';

@Injectable()
export class ProductsEffects {
  loadProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productsActions.loadProducts),
      switchMap(({ loadOptions }) =>
        this.productsApiService.getProducts(loadOptions).pipe(
          map((response) => productsActions.loadProductsSuccess({ response })),
          catchError((error) =>
            of(productsActions.loadProductsFailed({ error }))
          )
        )
      )
    )
  );

  createProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productsActions.createProduct),
      switchMap(({ product }) =>
        this.productsApiService.createProduct(product).pipe(
          switchMap(() => [
            productsActions.createProductSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_product_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(productsActions.createProductFailed({ error }))
          )
        )
      )
    )
  );

  updateProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productsActions.updateProduct),
      switchMap(({ product }) =>
        this.productsApiService.updateProduct(product).pipe(
          switchMap((response) => [
            productsActions.updateProductSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.edit_product_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(productsActions.updateProductFailed({ error }))
          )
        )
      )
    )
  );

  deleteProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productsActions.deleteProduct),
      switchMap(({ product }) =>
        this.productsApiService.deleteProduct(product).pipe(
          switchMap(() => [
            productsActions.deleteProductSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_product_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(productsActions.deleteProductFailed({ error }))
          )
        )
      )
    )
  );

  deleteProductsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productsActions.deleteProductsList),
      switchMap(({ products }) =>
        this.productsApiService.deleteProductList(products).pipe(
          switchMap(() => [
            productsActions.deleteProductsListSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_products_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(productsActions.deleteProductsListFailed({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private productsApiService: MwProductApiService
  ) {}
}
